/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../use.store';
import Placeholder from '../img/placeholder-img.png';
import Transparent from '../img/placeholder-img-null.png';

const ImageChecker = observer(
    ({
        src,
        className,
        isCard = false,
        useDefault = true,
        fileType = 'image/png',
    }) => {
        const { mainStore } = useStores();
        const { s3Url } = mainStore.config || {};

        const fallbackImage = useDefault
            ? mainStore.placeholderImage
                ? `${s3Url}/poi/${mainStore.placeholderImage}`
                : Placeholder
            : Transparent;

        const [imageStatus, setImageStatus] = useState('loading');
        const [finalSrc, setFinalSrc] = useState(fallbackImage);

        const resolveSrc = (path) => {
            if (!path) return fallbackImage;
            return `${s3Url}/${path}`;
        };

        useEffect(() => {
            setFinalSrc(resolveSrc(src));
            setImageStatus('loading');
        }, [src, s3Url]);

        const handleError = () => {
            if (imageStatus !== 'error') {
                setFinalSrc(fallbackImage);
                setImageStatus('error');
            }
        };

        const handleLoad = () => {
            if (imageStatus !== 'success') {
                setImageStatus('success');
            }
        };

        if (fileType === 'video/mp4') {
            return (
                <video
                    controls={false}
                    autoPlay
                    muted
                    playsInline
                    loop
                    className={className}
                >
                    <source
                        src={resolveSrc(src)}
                        type="video/mp4"
                        onError={handleError}
                    />
                </video>
            );
        }

        return (
            <img
                src={finalSrc}
                alt=""
                onLoad={handleLoad}
                onError={handleError}
                className={
                    isCard
                        ? `${className} transition-opacity duration-500 ease-in-out ${
                              imageStatus === 'success'
                                  ? 'opacity-100'
                                  : 'opacity-0 object-cover'
                          }`
                        : `${className} ${
                              imageStatus === 'success' ? '' : 'object-cover'
                          }`
                }
            />
        );
    }
);

export default ImageChecker;
